import React, { useContext, useState, useEffect, useMemo, useCallback } from 'react';

import { Tabs } from '@vtblife/uikit';

import { TabOptionValue } from '@vtblife/uikit/dist/components/tabs/types';

import styles from './tabs-for-public-area-mobile.module.css';
import { PartnersButton } from '../partners-button/partners-button';
import { TabsIds } from '../constants';
import { HeaderContextValue } from '../header-context';
import { hasStorage } from '../../utils';
import { MenuItemForTabsPublicMobile } from '../menu-item-for-tabs-public-mobile/menu-item-for-tabs-public-mobile';
import { getFilteredMenuItems } from '../utils';
import { sendAnalyticsEvent } from '../../analytics';

export const TabsForPublicAreaMobile = () => {
    const { items, pathname, partners, activePartner, onPartnerClick } = useContext(HeaderContextValue);

    const filteredItems = useMemo(() => getFilteredMenuItems(items, 'mobile'), [items]);

    const hasSessionStorage = hasStorage('sessionStorage');

    const [selectedTabId, setSelectedTabId] = useState(filteredItems[0]?.id || '');

    useEffect(() => {
        if (hasSessionStorage) {
            const saved = sessionStorage.getItem('selectedTabId');
            if (saved && filteredItems.some((item) => item.id === saved)) {
                setSelectedTabId(saved);
            }
        }
    }, [filteredItems, hasSessionStorage]);

    const currentMenuItem = filteredItems.find((item) => item.id === selectedTabId);
    const currentDropDownMenu = currentMenuItem?.dropdownMenu || [];

    const handleChangeTab = useCallback(
        (value: TabOptionValue) => {
            const tabId = value.toString();
            setSelectedTabId(tabId);

            if (hasSessionStorage) {
                sessionStorage.setItem('selectedTabId', tabId);
            }
            const tab = filteredItems.find((item) => item.id === tabId);
            if (tab) {
                sendAnalyticsEvent({
                    event: 'header_click',
                    user_type: tab.displayNameMobile || tab.displayName,
                    product_type: tab.displayNameMobile || tab.displayName,
                });
            }
        },
        [filteredItems, hasSessionStorage],
    );

    return (
        <>
            <div className={styles.tabs} data-test="header-tabs">
                <Tabs justified size="s" variant="badge" onChange={handleChangeTab} data-test="header-tab-container">
                    {filteredItems.map((item) => (
                        <Tabs.Option key={item.id} value={item.id} active={item.id === selectedTabId}>
                            {item.displayNameMobile || item.displayName}
                        </Tabs.Option>
                    ))}
                </Tabs>
                <div className={styles.menuContainer}>
                    {currentDropDownMenu.length !== 0 &&
                        currentDropDownMenu.map((item) => (
                            <MenuItemForTabsPublicMobile
                                key={`${selectedTabId}-${item.id}`}
                                item={item}
                                pathname={pathname}
                                parentTabTitle={currentMenuItem?.displayNameMobile || currentMenuItem?.displayName}
                            />
                        ))}
                </div>
            </div>
            {selectedTabId === TabsIds.DEFAULT && partners && (
                <div className={styles.partnersButtonContainer} data-test="header-tab-item">
                    <PartnersButton partners={partners} activePartner={activePartner} onPartnerClick={onPartnerClick} />
                </div>
            )}
        </>
    );
};
